
import { defineComponent, reactive, toRefs, watchEffect, ref, nextTick, watch, onMounted } from 'vue'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import TerminalViewTable from './_components/terminal-view-table/terminal-view-table.vue'
import LeakViewTable from './_components/leak-view-table/leak-view-table.vue'
import IgnoreViewTable from './_components/ignore-view-table/ignore-view-table.vue'
import Card from '@/views/dashboard/_components/card/card.vue'
import { TableViewMode } from '@/views/dashboard/_enum/table-view-mode'
import { useRoute, useRouter } from 'vue-router'
import TerminalDrawer
  from '@/views/dashboard/safe-status/vulnerability-fix/_components/terminal-drawer/terminal-drawer.vue'
import { ScanResult, TerminalDrawerService } from './_components/terminal-drawer/terminal-drawer.service'
import ContentAdaptLayout from '../../_components/content-adapt-layout/content-adapt-layout.vue'
import { VulnerabilityFixService, LeakList, LeakTerminalList } from '@/views/dashboard/safe-status/vulnerability-fix/vulnerability-fix.service'
import LeakSummaryCards from './_components/leak-summary-cards/leak-summary-cards.vue'
import RiskLeakChart from './_components/risk-leak-chart/risk-leak-chart.vue'
import LeakTerminalChart from './_components/leak-terminal-chart/leak-terminal-chart.vue'
import RepairDrawer from './_components/terminal-view-table/_components/repair-drawer.vue'
import CmSvgIcon from '@/components/cm-svg-icon/cm-svg-icon.vue'
export default defineComponent({
  components: {
    ContentAdaptLayout,
    TerminalViewTable,
    LeakViewTable,
    IgnoreViewTable,
    TerminalDrawer,
    RepairDrawer,
    Card,
    LeakSummaryCards,
    RiskLeakChart,
    LeakTerminalChart,
    CmSvgIcon
  },
  setup () {
    const injector = useReflectiveInjector([TerminalDrawerService, VulnerabilityFixService])
    const service = injector.get(TerminalDrawerService)
    const mainService = injector.get(VulnerabilityFixService)
    const route = useRoute()
    const router = useRouter()
    const taskId = localStorage.getItem('VULNERABILITY_SCAN_TSK_ID')
    const data = reactive({
      activeState: route.query.tab || 'terminal-view',
      terminalDrawer: false,
      refresh: false,
      scanResult: { isFinish: !taskId, success_count: 0, scan_total: 0 } as ScanResult
    })
    const scanTskId = ref<string>(taskId || '')
    const leakStat = reactive({
      leak_count: 0,
      terminal_count: 0
    })
    const terminalTableRef = ref()
    const leakTableRef = ref()
    const ignoreTableRef = ref()
    const terminalDrawerVisible = ref(false)
    const leakDrawerVisible = ref(false)
    const ignoreDrawerVisible = ref(false)
    /** 风险漏洞排行图：抽屉内列表按补丁编号筛选 */
    const leakDrawerKbQuery = ref('')
    const leakDrawerTableKey = ref(0)
    /** 统计卡片 / 抽屉：按终端列表预设「显示范围」 */
    const terminalDrawerInitialRange = ref<number | undefined>(undefined)
    /** 统计卡片：按漏洞列表预设 warn_level（1 可选、2 高危） */
    const leakDrawerInitialWarnLevel = ref<number | undefined>(undefined)
    /** 排行图点击终端：仅打开修复抽屉（不经「全部终端」） */
    const chartLeakRepairDrawerVisible = ref(false)
    const chartLeakRepairTerminal = ref<LeakTerminalList | null>(null)
    const chartLeakRepairDrawerKey = ref(0)

    function openTerminalDrawerAll () {
      terminalDrawerInitialRange.value = undefined
      terminalDrawerVisible.value = true
    }

    function onLeakTerminalChartRepairDrilldown (row: LeakTerminalList) {
      if (!row?.device_id) return
      chartLeakRepairTerminal.value = { ...row }
      chartLeakRepairDrawerKey.value += 1
      chartLeakRepairDrawerVisible.value = true
    }

    function onLeakSummaryDrilldown (payload:
      | { kind: 'terminal-high-risk' }
      | { kind: 'leak-list'; warnLevel: 1 | 2 }
    ) {
      if (payload.kind === 'terminal-high-risk') {
        terminalDrawerInitialRange.value = 1
        terminalDrawerVisible.value = true
        return
      }
      leakDrawerKbQuery.value = ''
      leakDrawerInitialWarnLevel.value = payload.warnLevel
      leakDrawerTableKey.value += 1
      leakDrawerVisible.value = true
    }

    function openLeakDrawerAll () {
      leakDrawerKbQuery.value = ''
      leakDrawerInitialWarnLevel.value = undefined
      leakDrawerTableKey.value += 1
      leakDrawerVisible.value = true
    }

    function onRiskLeakChartItemClick (row: LeakList) {
      leakDrawerInitialWarnLevel.value = undefined
      leakDrawerKbQuery.value = (row.kb_number || '').trim()
      leakDrawerTableKey.value += 1
      leakDrawerVisible.value = true
    }

    watch(terminalDrawerVisible, (open) => {
      if (!open) {
        nextTick(() => {
          terminalDrawerInitialRange.value = undefined
        })
      }
    })

    watch(chartLeakRepairDrawerVisible, (open) => {
      if (!open) {
        nextTick(() => {
          chartLeakRepairTerminal.value = null
        })
      }
    })

    watch(leakDrawerVisible, (open) => {
      if (!open) {
        nextTick(() => {
          leakDrawerKbQuery.value = ''
          leakDrawerInitialWarnLevel.value = undefined
        })
      }
    })
    function getTeamLeakStat(){
      mainService.getTeamLeakStat().then(res => {
      leakStat.leak_count = res.leak_count
      leakStat.terminal_count = res.terminal_count
    })
    }

    function reloadAllPreview () {
      terminalTableRef.value?.getData()
      leakTableRef.value?.getData()
      ignoreTableRef.value?.getData()
    }

    watchEffect(() => {
      if (scanTskId.value) {
        const interval = setInterval(() => {
          service.getScanResult({ task_id: scanTskId.value }).then(res => {
            if (res.isFinish) {
              data.refresh = true
              localStorage.removeItem('VULNERABILITY_SCAN_TSK_ID')
              clearInterval(interval)
            }
            data.scanResult = res
          })
          // eslint-disable-next-line no-magic-numbers
        }, 3000)
      }
    })
    onMounted(()=>{
      getTeamLeakStat()
      if (String(route.query.open_leak_drawer || '') === '1') {
        openLeakDrawerAll()
      }
    })
    return {
      ...toRefs(data),
      leakStat,
      reloadAllPreview,
      terminalTableRef,
      leakTableRef,
      ignoreTableRef,
      terminalDrawerVisible,
      leakDrawerVisible,
      ignoreDrawerVisible,
      leakDrawerKbQuery,
      leakDrawerTableKey,
      terminalDrawerInitialRange,
      leakDrawerInitialWarnLevel,
      chartLeakRepairDrawerVisible,
      chartLeakRepairTerminal,
      chartLeakRepairDrawerKey,
      openTerminalDrawerAll,
      onLeakTerminalChartRepairDrilldown,
      onLeakSummaryDrilldown,
      openLeakDrawerAll,
      onRiskLeakChartItemClick,
      TableViewMode,
      selectTerminals () {
        data.terminalDrawer = true
      },
      handleTerminalDrawerClose () {
        data.terminalDrawer = false
      },
      syncScanTskId (id: string) {
        data.scanResult.isFinish = false
        data.refresh = false
        scanTskId.value = id
      }
    }
  }
})
